import { atom } from "recoil";

export const globalDirtyState = atom<boolean>({
  key: "globalDirtyState",
  default: false,
});
